import React from 'react'
import PropTypes from 'prop-types'
import { ClassNames } from '@emotion/react'
import { DocusignAppDsLogoDefault, DocusignAppDsLogoInverse } from '@olive/svg'
import { dataProps } from '@ds/react-utils'
import { useDsUiDataProps } from '../../theming'
import styles from './styles'

export const docusignLogoColors = ['black', 'white'] as const
export type DocuSignLogoColor = 'black' | 'white'

const rebrandLogos = {
  black: DocusignAppDsLogoDefault,
  white: DocusignAppDsLogoInverse,
}

export interface DocuSignLogoProps {
  /**
   * The fill color to apply to the logo.
   */
  color?: DocuSignLogoColor
  /**
   * Accepts custom data attributes.
   */
  'data-.*'?: string
  'data-qa'?: string
  /**
   * Use the logo introduced in the 2024 rebrand
   * @deprecated This prop has no effect.
   */
  rebrand2024?: boolean
}

export function DocuSignLogo({
  color = 'black',
  ...restProps
}: DocuSignLogoProps) {
  const dsUiDataProps = useDsUiDataProps(DocuSignLogo)

  const Logo = rebrandLogos[color]

  return (
    <span {...dsUiDataProps} {...dataProps(restProps)}>
      <ClassNames>
        {({ css }) => (
          <Logo
            aria-label="Docusign"
            className={css(styles.DocuSignLogo)}
            height="100%"
            role="img"
            width="100%"
          />
        )}
      </ClassNames>
    </span>
  )
}

DocuSignLogo.colors = docusignLogoColors

DocuSignLogo.propTypes = {
  color: PropTypes.oneOf(DocuSignLogo.colors),
  'data-.*': PropTypes.string,
  rebrand2024: PropTypes.bool,
}

DocuSignLogo.displayName = 'DocuSignLogo'
